import styled from 'styled-components/native';

export const Content = styled.View`
  padding-horizontal: 16px;
  padding-top: 16px;
`;
